<template>
    <div class="topclass-parejas">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-xl-4 text-center p-0">
                    <div class="topclass-parejas-wrap topclass-parejas-wrap-card bg-gris 100vh">
                        <div class="topclass-parejas-card pt-3 px-4"><img :src="require('@/assets/galerias/logo_topclass_color.svg')" class="img-fluid img-logo my-2" alt="Logo Topclass"> <img :src="require('@/assets/galerias/checkmark_round.svg')" class="img-fluid d-block my-2 mx-auto" alt="Logo Topclass">
                            <p class="topclass-parejas-eb fs-5 text-black">¡Felicidades!</p>
                            <p class="text-black fs-5">Ya puedes disfrutar de Topclass por $3.490/mes</p>
                            <p class="topclass-parejas-small my-2">Desde ahora recibirás el cobro recurrente con <strong>cargo a tu boleta o saldo Movistar</strong></p>
                            <p class="topclass-parejas-small mb-0">Para tu número</p>
                            <p class="topclass-parejas-telefono text-black fw-bold fs-5">+ {{ telefono }}</p><a class="btn btn-rosado d-block my-1" @click="proxyUser" role="button">Ver Cursos</a> <small class="topclass-parejas-terminos text-start d-block">Recuerda:<ul><li>Puedes darte de baja en cualquier momento enviando un <strong>SMS con el texto SALIR al 7600 sin costo</strong></li><li>El precio incluye IVA</li><li>Puedes revisar los <strong>Términos y Condiciones</strong></li></ul></small></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
body {
    background-color: white;
}
</style>
<script>

export default {
    name: "LpMovistarFelicitaciones",
    data() {
        return {
            telefono: this.$route.params.msisdn,
        };
    },
    methods: {
        proxyUser(){
            window.location.href = "https://cms.topclass.academy/thinkific/auth?msisdn="+ this.telefono
        },
    },
    mounted() {
        if (this.telefono) {
            setTimeout(() => {
                this.proxyUser();
            }, 3000);
        }
    },
    created() {
        if (!this.telefono) {
            this.$router.push({ name: "error404" });
        }
    },
};
</script>
